import { useEffect, useRef } from 'react'

export function useDebounceCallback<TCallback extends (...args: any[]) => any>(callback: TCallback, delay?: number) {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null)

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        }
    }, [])

    const debouncedCallback = (...args: Parameters<TCallback>) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
        }

        timeoutRef.current = setTimeout(() => {
            callback(...args)
        }, delay || 500)
    }

    return debouncedCallback
}
